import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useQueryState } from "nuqs";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader } from "../../../../MainComponents";
import { useAuthState } from "../../../../MainComponents/GlobalContext.jsx";
import HelmetTags from "../../../../MainComponents/HelmetTags";
import useAxios from "../../../../MainComponents/Hooks/useAxios.jsx";
import SingleChapter from "../../../../MainComponents/SingleChapter";
import SingleCourse from "../../../../MainComponents/SingleCourse";
import SingleCourseCode from "../../../../MainComponents/SingleCourseCode.jsx";

function AdminLectures() {
  const navigate = useNavigate();
  const AuthState = useAuthState();
  const [reFetch, setReFetch] = useState(false);
  const [academicSection, setAcademicSection] = useQueryState("section", {
    defaultValue: "all",
  });
  const [academicLevel, setAcademicLevel] = useQueryState("level", {
    defaultValue: "11",
  });

  const [allLecturesData, allLecturesErrors, allLecturesloading] = useAxios(
    process.env.REACT_APP_ADMIN_LECTURES_TAB_API,
    "GET",
    "GET",
    reFetch
  );

  const filteredLectures = allLecturesData?.data?.filter((lecture) => {
    if (academicSection === "all") return +lecture.stage === +academicLevel;
    if (academicSection === "chapter")
      return lecture.is_chapter === true && +lecture.stage === +academicLevel;
    if (academicSection === "lecture")
      return lecture.is_lecture === true && +lecture.stage === +academicLevel;

    return;
  });

  return (
    <section
      className={`  h-auto  w-full  px-20 py-20  dark:bg-dark dark:text-light `}
    >
      <HelmetTags title="المحاضرات | مسيو بلال عبدالله "></HelmetTags>
      <div className="mb-32 flex flex-col items-end gap-20">
        <h2 className="w-full text-end text-4xl font-bold md:text-center">
          المحاضرات
        </h2>{" "}
        {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
          AuthState.userData?.admin?.permissions?.some((permission) =>
            permission.name.startsWith("lecture_add")
          )) && (
          <div className="flex w-full justify-end gap-10 md:flex-col md:justify-evenly">
            <button
              onClick={() => navigate("/admin/lectures/add-lecture")}
              className="ml-4 md:w-full flex items-center justify-center rounded-xl border-2 border-secondary bg-light px-2 py-1 font-semibold text-secondary transition-all duration-300 hover:bg-secondary hover:text-light   active:scale-90 "
            >
              <FontAwesomeIcon className="mr-4" icon={faPlus} />
              اضافة محاضرة
            </button>
            <button
              onClick={() => navigate("/admin/lectures/add-chapter")}
              className="ml-4 md:w-full flex items-center justify-center rounded-xl border-2 border-secondary bg-secondary px-2 py-1 font-semibold text-light transition-all duration-300 hover:bg-light hover:text-secondary   active:scale-90 "
            >
              <FontAwesomeIcon className="mr-4" icon={faPlus} />
              اضافة فصل
            </button>
          </div>
        )}
      </div>
      <div className="flex w-full flex-row-reverse  md:flex-col pb-20 gap-10 md:justify-center sm:flex-col-reverse sm:items-center">
        <button
          onClick={() => {
            setAcademicSection("all");
          }}
          className={`min-w-[200px] rounded-xl border-2 border-secondary p-4 font-semibold  transition-all duration-300 hover:bg-light hover:text-secondary   active:scale-90 ${
            academicSection === "all" && "bg-secondary text-light"
          }`}
        >
          الكل
        </button>
        <button
          onClick={() => {
            setAcademicSection("lecture");
          }}
          className={`min-w-[200px] rounded-xl border-2 border-secondary p-4 font-semibold  transition-all duration-300 hover:bg-light hover:text-secondary   active:scale-90 ${
            academicSection === "lecture" && "bg-secondary text-light"
          }`}
        >
          المحاضرات
        </button>

        <button
          onClick={() => {
            setAcademicSection("chapter");
          }}
          className={`min-w-[200px] rounded-xl border-2 border-secondary p-4 font-semibold  transition-all duration-300 hover:bg-light hover:text-secondary   active:scale-90 ${
            academicSection === "chapter" && "bg-secondary text-light"
          }`}
        >
          الفصول
        </button>
      </div>
      <div className="flex w-full  pb-20 justify-end gap-10 md:justify-center md:flex-col-reverse sm:items-center">
        <button
          onClick={() => {
            setAcademicLevel("3");
          }}
          className={`md:w-full flex items-center justify-center rounded-xl border-2 border-secondary  px-2 py-1 font-semibold  transition-all duration-300 hover:bg-light hover:text-secondary   active:scale-90 ${
            academicLevel === "3" && "bg-secondary text-light"
          }`}
        >
          الصف الثالث الثانوي
        </button>

        <button
          onClick={() => {
            setAcademicLevel("2");
          }}
          className={`md:w-full flex items-center justify-center rounded-xl border-2 border-secondary  px-2 py-1 font-semibold  transition-all duration-300 hover:bg-light hover:text-secondary   active:scale-90 ${
            academicLevel === "2" && "bg-secondary text-light"
          }`}
        >
          الصف الثاني الثانوي
        </button>
        <button
          onClick={() => {
            setAcademicLevel("1");
          }}
          className={`md:w-full flex items-center justify-center rounded-xl border-2 border-secondary  px-2 py-1 font-semibold  transition-all duration-300 hover:bg-light hover:text-secondary   active:scale-90 ${
            academicLevel === "1" && "bg-secondary text-light"
          }`}
        >
          الصف الأول الثانوي
        </button>
        <button
          onClick={() => {
            setAcademicLevel("33");
          }}
          className={`md:w-full flex items-center justify-center rounded-xl border-2 border-secondary  px-2 py-1 font-semibold  transition-all duration-300 hover:bg-light hover:text-secondary   active:scale-90 ${
            academicLevel === "33" && "bg-secondary text-light"
          }`}
        >
          ثالثة الاعدادي
        </button>
        <button
          onClick={() => {
            setAcademicLevel("22");
          }}
          className={`md:w-full flex items-center justify-center rounded-xl border-2 border-secondary  px-2 py-1 font-semibold  transition-all duration-300 hover:bg-light hover:text-secondary   active:scale-90 ${
            academicLevel === "22" && "bg-secondary text-light"
          }`}
        >
          ثانية الاعدادي
        </button>
        <button
          onClick={() => {
            setAcademicLevel("11");
          }}
          className={`md:w-full flex items-center justify-center rounded-xl border-2 border-secondary  px-2 py-1 font-semibold  transition-all duration-300 hover:bg-light hover:text-secondary   active:scale-90 ${
            academicLevel === "11" && "bg-secondary text-light"
          }`}
        >
          أولى الاعدادي
        </button>
      </div>
      {allLecturesloading ? (
        <Loader />
      ) : (
        <div className="lectures grid-auto-fit">
          {allLecturesData?.data?.length === 0 ? (
            <p>لا يوجد محاضرات</p>
          ) : (
            filteredLectures?.map((Card) => {
              if (Card.is_chapter === true) {
                return (
                  <SingleChapter
                    reFetch={reFetch}
                    setReFetch={setReFetch}
                    admin
                    chapter={Card}
                    key={Card.key}
                  />
                );
              } else {
                return (
                  <SingleCourse
                    reFetch={reFetch}
                    setReFetch={setReFetch}
                    admin
                    lecture={Card}
                    key={Card.key}
                  />
                );
              }
            })
          )}
        </div>
      )}
    </section>
  );
}

export default AdminLectures;
